import { Component, Log, CacheStorage } from '@WidgetWorks';
import { BrowserCheckSum } from 'browser-checksum';

export default class HuggerCTA extends Component {
    /// !!! This is a special CTA that will use the same pathways as upload.

    constructor(appConfig) {
        super(appConfig);
        this.interacted = false;
        this.whiteList = appConfig.appFactory.config.hugger_app.whiteList;
        this.blackListQueriesDefault = appConfig.appFactory.config.hugger_app.blacklist_queries;
        this.huggerConfig = appConfig.appFactory.config.hugger_app;
        this.pageRules = this.getPageRules();
        this.blackList = [...this.pageRules.blacklist_queries, ...this.blackListQueriesDefault];

        // UUID -> {imageSum, imageURL, imageFile}
        this.imageRecommendationDetails = new Map();

        this.rejectedImages = new Set();
        this.validImages = new Set();
    }

    overrideHook() {
        return true;
    }

    preRenderHook() {
        return true;
    }

    beforeMountHook() {
        this.root = this.element.shadowRoot.querySelector('section');

        // Position relative to the parent.
        // Without padding / margins
        // const computedStyle = window.getComputedStyle(this.element);
        // const paddingTop = parseFloat(computedStyle.paddingTop);
        // const paddingBottom = parseFloat(computedStyle.paddingBottom);
        // const paddingLeft = parseFloat(computedStyle.paddingLeft);
        // const paddingRight = parseFloat(computedStyle.paddingRight);
        // const marginTop = parseFloat(computedStyle.marginTop);
        // const marginBottom = parseFloat(computedStyle.marginBottom);
        // const marginLeft = parseFloat(computedStyle.marginLeft);
        // const marginRight = parseFloat(computedStyle.marginRight);

        const width = '100%';
        const height = '100%';

        this.element.style.position = 'relative';
        this.element.style.width = width;
        this.element.style.height = height;

        // Make sure it's always clickable and on top
        // this.element.style.zIndex = '999999999';

        return true;
    }

    postElementMount() {
        // see retailer config
        return true;
    }

    postRenderHook() {
        // Any animations, would be a good idea to apply here.
        // Now it's been rendered, note that this counts as a button display event
        // this.analytics.registerEvent('button_display', 1, 'FCBP');
        return true;
    }

    firstClickAnalytics() {
        const firstClickedFlag = CacheStorage.get('PRIME_AI_HUGGER_APP_FIRST_CLICKED_BUTTON');
        if (firstClickedFlag) return false;
        this.analytics.registerEvent('button_clickfirsttime', 1, 'PhotoHugger');
        CacheStorage.set('PRIME_AI_HUGGER_APP_FIRST_CLICKED_BUTTON', true, CacheStorage.expirationEndOfDay());
        return true;
    }

    firstInteractionHook() {
        if (this.interacted) return false;
        this.interacted = true;
        console.log(...Log.w('HuggerCTA', 'LOG', 'First Interaction'));

        // First time they clicked the button analytical event
        // will run at the same time as button click.
        this.firstClickAnalytics();
        return true;
    }

    async init() {
        console.log(...Log.w('HuggerCTA', 'LOG', 'Initialising...'));

        // This hook will run the custom function defined in the override itself.
        this.overrideHook();

        // ! 0.6, grab the product-ids ahead of time
        // ! and check they exist.
        // ! maintain an internal memo of existing products / non existing
        // ! make a note of all of those existing / not exist.
        // ! during the mounting phase, if the product is not found, don't mount it. isElementAllowedToMount()
        // Before rendering, do these things.
        this.preRenderHook();

        // Insert CSS into virtual element
        this.insertCSS(this.styles);

        // Insert HTML into virtual element
        this.insertHTML(this.markup);

        // Update HTML with Languages into the virtual element
        this.insertLanguages(this.language);

        // Run the pre mounted hook.
        this.beforeMountHook();

        // Once the mount point is available, create copies
        // and mount it.
        const images = document.querySelectorAll('img');
        await this.mountElements(images);
        this.listenForNewMountPoints();

        // Now mounted, run the post hooks
        this.postRenderHook();

        console.log(...Log.w('HuggerCTA', 'LOG', 'Initialised'));
    }

    insertLanguages(langs) {
        // Dynamic insertion using a recursive post order
        // technique is the default function to insertion of languages
        // feel free to override.
        this.recursiveLanguageInsertion(langs, '');
        return true;
    }

    filterByImageExtension(images, validExtensions) {
        const validImages = [];
        for (let i = 0; i < images.length; i++) {
            const image = images[i];
            const { src } = image;
            const extension = src.split('.').pop().split('?')[0];
            if (validExtensions.includes(extension)) {
                validImages.push(image);
            } else {
                this.rejectedImages.add(image);
            }
        }
        return validImages;
    }

    getPageRules() {
        // The whitelist is a list of regex patterns that the current URL must match!
        // if no url matches, the app will not run.
        const currentUrl = window.location.href.split('?')[0];

        for (const entry of this.whiteList) {
            const { pattern } = entry;
            const regex = new RegExp(pattern);
            if (regex.test(currentUrl)) {
                // Now, does the entry have a specific configuration?
                // if not, return the default.
                entry.min_height_percentage = entry?.min_height_percentage || this.huggerConfig.defaults.min_height_percentage;
                entry.min_width_percentage = entry?.min_width_percentage || this.huggerConfig.defaults.min_width_percentage;
                entry.max_height_percentage = entry?.max_height_percentage || this.huggerConfig.defaults.max_height_percentage;
                entry.max_width_percentage = entry?.max_width_percentage || this.huggerConfig.defaults.max_width_percentage;

                console.log(...Log.w(`${this.constructor.name}`, 'LOG', `Getting whitelist for URL: ${currentUrl} | ${pattern}`));
                return entry;
            }
        }

        console.log(...Log.w(`${this.constructor.name}`, 'LOG', `Using default whitelist. URL: ${currentUrl}`));
        return this.whiteList.defaults;
    }

    filterImagesByParent(images, blackListTags) {
        // Must contain only 1 image (for now)
        // Must be a direct child of a div
        // !! The reason for this is multiple images
        // !! will expand it's container and mess up our mounting.
        // !! The reason for the div is that images are allowed to be nested
        // !! unlike p tags.

        const valid = [];
        for (const image of images) {
            const parent = image.parentElement;
            const isNotAInvalidChild = blackListTags.includes(parent.tagName.toLowerCase());
            const hasOnlyOneImage = parent.querySelectorAll('img').length === 1;
            if (!isNotAInvalidChild && hasOnlyOneImage) {
                valid.push(image);
            } else {
                this.rejectedImages.add(image);
            }
        }
        return valid;
    }

    removeBlackListedImages(images) {
        for (const query of this.blackList) {
            const blacklistedImages = document.querySelectorAll(query);
            for (let i = 0; i < blacklistedImages.length; i++) {
                const image = blacklistedImages[i];
                if (images.includes(image)) {
                    this.rejectedImages.add(image);
                    blacklistedImages[i] = null;
                }
            }
        }

        return images.filter((image) => image !== null);
    }

    doesElementMeetSizeRequirements(image) {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        const { width, height } = image;

        // Calculate the percentage of the image relative to the screen.
        const widthPercentage = (width / screenWidth) * 100;
        const heightPercentage = (height / screenHeight) * 100;

        // Given the current location of the button. If it's outside of the width of the screen, reject it.
        const buttonRect = image.getBoundingClientRect();
        const buttonLeft = buttonRect.left;
        const buttonRight = buttonRect.right;
        const withinScreenWidth = (buttonLeft >= 0 && buttonRight <= screenWidth);

        // Natural width and height are 0, the image has not been fully loaded
        const imageLoaded = (image.naturalWidth > 0 && image.naturalHeight > 0 && image.complete);

        // Baseline minimum check based on the width of the button.
        // So for example, is it less than 200px? We don't mount to an image where the button will be bigger.
        const isButtonSmallerThanImage = (width > 200);
        const isButtonSmallerThanImageHeight = (height > 200);
        const meetsAbsoluteMinimum = (isButtonSmallerThanImage && isButtonSmallerThanImageHeight);

        // If the images do not meet the minimum or maximum requirements, remove them.
        const isGreaterThanMin = (widthPercentage >= this.pageRules.min_width_percentage && heightPercentage >= this.pageRules.min_height_percentage);
        const isLessThanMax = (widthPercentage <= this.pageRules.max_width_percentage && heightPercentage <= this.pageRules.max_height_percentage);
        if (isGreaterThanMin && isLessThanMax && withinScreenWidth && imageLoaded && meetsAbsoluteMinimum) {
            return true;
        }
        return false;
    }

    async mountElements(providedImages) {
        // The mounting of this component is a little different
        // For a matter of fact, it's very unique.
        // The hugger does not utilise the standard mountComponentToPoints
        // As that is reliant on css / query selector styled mounting.

        // The mounting of this app is entirely based on Javascript.
        // As the goal of this app is to mount itself to images, that of which cannot be done
        // because images are not allowed to be nested. Therefore, we need to
        // mount to the parent of the images container. Calculate the offset and then place itself.

        // Filter out images that already blacklisted / have already been mounted.

        // !! Add back in when going prod
        // for (const image of this.rejectedImages) {
        //     if (providedImages.includes(image)) {
        //         console.log('REJECTED IMAGE PROVIDED!');
        //         providedImages.splice(providedImages.indexOf(image), 1);
        //     }
        // }

        for (const image of this.validImages) {
            if (providedImages.includes(image)) {
                console.log('ALREADY MOUNTED IMAGE PROVIDED!');
                providedImages.splice(providedImages.indexOf(image), 1);
            }
        }

        // Get all the elements that are allowed to be mounted. (Being all images)
        let images = providedImages;
        images = this.filterByImageExtension(images, ['jpg', 'jpeg', 'png', 'webp']);
        images = this.filterImagesByParent(images, ['a']);
        images = this.removeBlackListedImages(images);

        // !! For now, for quicker development, does the images parent be a valid tag?
        // !! For example, some people nest images in 'a' tags or 'p' tags and that's invalid
        // !! for our purposes. We need to filter out those images.

        // Of the valid images so far.
        // We need to check if their size.
        // The image must make up at least 5% in height and width relative to the screen.
        const rejects = [];
        const validImages = [];

        for (let i = 0; i < images.length; i++) {
            const doesImageMeetSizeRequirements = this.doesElementMeetSizeRequirements(images[i]);

            // Every 250ms check if the image still meets the requirements.
            // If it doesn't, remove it.
            setInterval(() => {
                const stillMeetsRequirements = this.doesElementMeetSizeRequirements(images[i]);
                if (!stillMeetsRequirements) {
                    this.rejectedImages.add(images[i]);
                    rejects.push(images[i]);
                }
            }, 250);

            if (doesImageMeetSizeRequirements) {
                validImages.push(images[i]);
            } else {
                this.rejectedImages.add(images[i]);
                rejects.push(images[i]);
            }
        }

        // Need to unload in case of img load failure
        const mountPoints = [];
        for (const image of validImages) {
            mountPoints.push(image.parentElement);
        }

        const newElements = await this.mountElementToPoint(mountPoints, validImages);
        const point = this.appConfig.elements[0];

        // Insert attributes into the new elements  (Non Ghost Mounts.)
        newElements.forEach((elm) => {
            const root = this.getElementRoot(elm);
            root.setAttribute('mountId', point.mount_id);
            root.setAttribute('language', this.productPageInfo.languageCode);
            point.attributes.forEach((attr) => {
                const [name, value] = attr.split('=');
                root.setAttribute(name, value);
            });
        });

        // Add elements to the allowed set
        validImages.forEach((elm) => this.validImages.add(elm));

        // Any other logic required for this app.
        // In this case, mount event listeners.
        this.createEventListeners(newElements);

        // Does it require any special logic for the CTA?
        this.postElementMount(newElements);

        // return result;
    }

    async mountElementToPoint(elements, children) {
        const newElements = [];
        if (elements.length > 0) {
            elements.forEach(async (targetElement, i) => {
                const clone = this.deepClone(this.element);
                targetElement.appendChild(clone);
                this.elementCopies.push(targetElement.lastElementChild);
                newElements.push(targetElement.lastElementChild);

                const nestedImage = children[i];
                const root = targetElement.lastElementChild.shadowRoot.querySelector('section');

                // Set id on parent and image itself.
                const uniqueId = `id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
                root.setAttribute('uid', uniqueId);
                const checkSum = await BrowserCheckSum.checkSum(nestedImage.src);
                this.imageRecommendationDetails.set(uniqueId, {
                    uniqueId, imageSum: checkSum, imageURL: nestedImage.src, imageFile: null, element: nestedImage,
                });

                // Wait until the element has mounted to the screen
                // await new Promise((resolve) => {
                //     const observer = new MutationObserver(() => {
                //         if (document.body.contains(targetElement.lastElementChild)) {
                //             observer.disconnect();
                //             resolve();
                //         }
                //     });
                //     observer.observe(document.body, { childList: true });
                // });

                // Get the coordinates of the new element
                const rect = targetElement.lastElementChild.shadowRoot.querySelector('section').getBoundingClientRect();
                // const x = rect.left + window.pageXOffset;
                // const y = rect.top + window.pageYOffset;
                // const { width } = rect;
                // const { height } = rect;

                // Create a new square element
                const overlay = document.createElement('section');
                overlay.style.position = 'absolute';
                overlay.style.left = `${rect.left + window.pageXOffset}px`;
                overlay.style.top = `${rect.top + window.pageYOffset}px`;
                overlay.style.width = `${rect.width}px`;
                overlay.style.height = `${rect.height}px`;
                overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.0)'; // Semi-transparent red
                overlay.style.opacity = '0'; // Semi-transparent red
                // overlay.style.visibility = 'hidden'; // Semi-transparent red
                overlay.style.display = 'unset!important'; // Allow clicks to pass through
                overlay.style.zIndex = '3'; // Allow clicks to pass through
                overlay.style.overflow = 'hidden'; // Allow clicks to pass through
                overlay.style.cursor = 'pointer'; // Allow clicks to pass through

                // To tie the overlay to it's CTA. Which is thus tied to the image.
                // Overlay -> CTA -> Image
                overlay.setAttribute('uid', uniqueId);

                // Append the square to the body
                this.createEventListeners([overlay]);
                document.body.appendChild(overlay);

                // Update the position of the square when the window is resized
                setInterval(() => {
                    const updatedRect = targetElement.lastElementChild.shadowRoot.querySelector('section').getBoundingClientRect();
                    const updatedX = updatedRect.left + window.pageXOffset;
                    const updatedY = updatedRect.top + window.pageYOffset;
                    overlay.style.left = `${updatedX}px`;
                    overlay.style.top = `${updatedY}px`;
                }, 500);
            });
        }
        return newElements;
    }

    topLevelClickAnalytics() {
        this.analytics.registerEvent('button_click', 1, 'VisualSearchParentApp');

        // Check if the user is unique.
        const flagExists = CacheStorage.get('PRIME_AI_VISUAL_SEARCH_FIRST_CLICKED_BUTTON');

        // If the user is unique, register a unique visitor event.
        // and set a flag to say they are no longer unique.
        if (!flagExists) {
            this.analytics.registerEvent('button_clickfirsttime', 1, 'VisualSearchParentApp');
            CacheStorage.set('PRIME_AI_VISUAL_SEARCH_FIRST_CLICKED_BUTTON', true, CacheStorage.expirationEndOfDay());
        }
    }

    listenForNewMountPoints() {
        const observer = new MutationObserver((mutationsList) => {
            const newImages = [];

            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const { addedNodes } = mutation;
                    for (const node of addedNodes) {
                        if (node.nodeName === 'IMG') {
                            newImages.push(node);
                        }
                    }
                    // Do any of the nodes children contain images?
                    for (const node of addedNodes) {
                        if (!node.querySelectorAll) continue;
                        const images = node.querySelectorAll('img');
                        for (const image of images) {
                            newImages.push(image);
                        }
                    }
                }
            }

            if (newImages.length === 0) return;
            this.mountElements(newImages);
        });

        // Every 3 seconds, check if there are new images.
        setInterval(() => {
            const images = document.querySelectorAll('img');
            const newImages = Array.from(images);
            if (newImages.length === 0) return;
            this.mountElements(newImages);
        }, 3000);

        observer.observe(document.body, { childList: true, subtree: true });
    }

    createEventListeners(elements) {
        for (const element of elements) {
            const elm = this.getElementRoot(element);
            elm.addEventListener('click', (event) => {
                event.preventDefault();
                this.openRecommendationWindow(event);
            });
        }
    }

    openRecommendationWindow(event) {
        // Analytics for someone has clicked the button
        this.analytics.registerEvent('button_click', 1, 'PhotoHugger');
        this.topLevelClickAnalytics();

        // Set into localstorage.
        this.firstInteractionHook();
        const imageDetails = this.imageRecommendationDetails.get(event.currentTarget.getAttribute('uid'));

        // Prepare the payload required for the recommendation window.
        const payload = {
            imageDetails,
            imageRecommendationDetails: this.imageRecommendationDetails,
            productPageInfo: this.productPageInfo,
        };

        // Arguments from the parent can be used in the internal app.
        // So here we extract all the arguments from the parent.
        // Given these argument we decide what behaviour is expected.
        // For example, we can pass a image_url and instead of making the user
        // upload an image, it downloads the one from the given url.
        // Although this app, will only forward these details to the appToDisplay.
        // The external app is expected to have this.
        this.connections.huggerRecommendation.openApp(payload);
    }
}
